import { NotificationService } from "../services/notification.service";

export abstract class CriteriaAbs {
  constructor(
    protected notificationService: NotificationService,
  ) {}
}
